<template>
  <div>
    <aha-modal
      :title="title"
      @hide="$emit('hide')"
      action-position="justify-center"
    >
      <aha-multi-tabs
        @onChangeTab="onChangeTab"
        :tabTitles="tabNames"
        :defaultTabIndex="0"
      >
      </aha-multi-tabs>
      <KeepAlive>
        <component
          :name="'MovePresentationTo' + tabContent"
          v-aha-emit-action.view
          :is="tabContent"
        >
          <template #interactive-button-section>
            <div name="additional" v-if="!onlyRootOrNoneV2">
              <div
                class="flex items-center font-bold cursor-pointer text-primary-90"
                :class="{'hidden': isNewFolderButtonHiddenV2}"
                @click="handleShowModalCreateNewFolder()"
              >
                <aha-icon
                  name="add"
                  height="18"
                  width="18"
                  viewBox="0 0 24 24"
                />
                <p class="pl-2">
                  {{ $i18nPresenter.t("New Folder") }}
                </p>
              </div>
            </div>
            <div class="flex items-center">
              <aha-antd-button
                variant="secondary"
                v-aha-emit-action
                name="move-presentation-cancel"
                @click="hide()"
              >
                <span>{{ $i18nPresenter.t("Cancel") }}</span>
              </aha-antd-button>
              <aha-antd-button
                v-if="!onlyRootOrNoneV2"
                v-aha-emit-action
                name="move-presentation"
                :disabled="isMovingPresn"
                @click="handleMovePresn()"
                icon-name="move"
                :submitting="isMovingPresn"
                class="ml-4"
              >
                {{ $i18nPresenter.t("Move") }}
              </aha-antd-button>
              <aha-antd-button
                v-if="showCreateFolder"
                v-aha-emit-action
                name="create-new-folder"
                @click="handleShowModalCreateNewFolder()"
                class="ml-4"
              >
                {{ $i18nPresenter.t("Create Folder") }}
              </aha-antd-button>
            </div>
          </template>
        </component>
      </KeepAlive>
    </aha-modal>

    <modal-create-new-folder
      :presentationIds="selectedPresentationIds"
      v-if="isModalCreateNewFolderShowing"
      @hide="hide()"
      :funcMovePresn="funcMovePresn"
      @updateDestinatedFolderId="(value) => $emit('updateDestinatedFolderId', value)"
      :folders="folders"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import MovePresentations from './MovePresentations.vue'
import TabMyPresentations from '../common/move-presentation/TabMyPresentations.vue'
import TabSharedWithMe from '../common/move-presentation/TabSharedWithMe.vue'

import ModalCreateNewFolder from '@/components-v2/modals/CreateNewFolder.vue'

export default {
  name: 'MovePresentationV2',
  components: {
    TabMyPresentations,
    TabSharedWithMe,
    ModalCreateNewFolder,
  },
  extends: MovePresentations,
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    tabContent: TabMyPresentations.name,
    selectedPresentation: null,
  }),
  computed: {
    ...mapGetters('movePresentation', {
      folders2: 'folders',
    }),
    tabs() {
      return [
        {
          key: 'my-presentations', // Đảm bảo key là duy nhất
          title: this.$i18nPresenter.t('My Presentations'),
          component: 'TabMyPresentations',
          name: TabMyPresentations.name,
        },
        {
          key: 'shared-with-me', // Đảm bảo key là duy nhất
          title: this.$i18nPresenter.t('Shared with Me'),
          component: 'TabSharedWithMe',
          name: TabSharedWithMe.name,
        },
      ]
    },
    tabNames() {
      return this.tabs.map((tab) => tab.title)
    },
    onlyRootOrNoneV2() {
      return !this.folders2.length || !this.folders2.some((p) => p.folderId != null)
    },
    isNewFolderButtonHiddenV2() {
      return (this.$route.name === 'FolderDetail' && this.currentFolderDepth >= this.parseIntMaxFolderDepth) || this.tabContent !== TabMyPresentations.name
    },
    showCreateFolder() {
      return this.onlyRootOrNoneV2 && this.tabContent === TabMyPresentations.name
    },
  },
  created() {
    this.updateTabContent(this.tabContent)

    this.updateSelectedPresentations(this.selectedPresentations)
  },
  methods: {
    ...mapActions('movePresentation', [
      'updateTabContent',
      'updateSelectedPresentations',
      'resetDestinatedFolder',
    ]),
    onChangeTab(index) {
      this.tabContent = this.tabs[index]?.name
      this.selectedPresentationId = null

      this.updateTabContent(this.tabContent)
      this.resetDestinatedFolder()
    },
  },
}
</script>
